import classNames from 'classnames';
import { TextareaHTMLAttributes, useEffect, useRef, useState } from 'react';
import { FieldLabel, FieldLabelProps } from '../field/field';

type TextAreaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'label'> &
  FieldLabelProps & { autoResize?: boolean; classNameWrapper?: string };

export const TextArea = ({
  value,
  rows,
  placeholder,
  style,
  className,
  classNameWrapper,
  label,
  labelType,
  labelWeight,
  isRequired,
  autoResize = true,
  dataCy,
  ...props
}: TextAreaProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const [initalHeight, setInitalHeight] = useState<number>(0);

  const resize = () => {
    if (!ref.current || !autoResize) return;

    if (initalHeight == 0) {
      setInitalHeight(ref.current.clientHeight);
    }

    if (ref.current.scrollHeight > initalHeight) {
      ref.current.style.height = 'auto';
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }
  };

  useEffect(resize, [value]);

  return (
    <div className={classNames('w-full', classNameWrapper)}>
      <FieldLabel label={label} labelType={labelType} labelWeight={labelWeight} isRequired={isRequired} />

      <textarea
        ref={ref}
        className={classNames('font-sans w-full', className)}
        rows={rows || 1}
        value={value}
        placeholder={placeholder || ''}
        style={{
          ...style,
          resize: 'none',
        }}
        data-cy={dataCy}
        {...props}
      />
    </div>
  );
};
